module.exports = __webpack_public_path__ + "assets/img/0824-gi.svg";